import React, {useState} from "react";
import { CheckBox } from "../../../common/custom-form/checkbox.component";
function EmailOptOut() {
    const [isChecked, setIsChecked] = useState(false);

    const checkBoxHandler=(e)=>{
        setIsChecked(e.target.checked);
    }
    return (
        <div className="email-opt-container">
            <p className="note-mark">Field marked with an asterisk (*) are mandatory to submit a request.</p>
            <div className="email-opt-sub-container">
                <input type="checkbox" className="email-opt-checkbox" checked={isChecked}  onChange={checkBoxHandler}/>
                <label className={`email-opt-label ${isChecked && "checkBoxActive"}`}>Email Opt-Out &nbsp;
                   
                </label>
               
            </div>
        </div>
    )
}

export default EmailOptOut;